import React from 'react';
import { Video, Film, Mic, Sparkles } from 'lucide-react';

const MediaProduction = () => {
  const services = [
    { icon: Video, text: 'Studio or on-site video production' },
    { icon: Film, text: 'Professional lighting, audio, and editing' },
    { icon: Mic, text: 'Role-play scenario filming' },
    { icon: Sparkles, text: 'Content structured for Traain Engine™ and Traain Cadence™' }
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="p-8 md:p-12 rounded-3xl bg-gradient-to-br from-gray-900/90 to-purple-900/30 border border-purple-500/30">
          <div className="text-center mb-8">
            <div className="inline-block px-4 py-2 bg-purple-500/10 border border-purple-500/30 rounded-full mb-4">
              <span className="text-purple-400 text-sm font-semibold">Optional Add-On</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
              Professional Media Production
            </h2>
            <p className="text-xl text-purple-400 font-semibold">
              Enterprise-Grade Traaining Content
            </p>
          </div>

          <p className="text-lg text-gray-300 mb-8 leading-relaxed text-center max-w-3xl mx-auto">
            For consultants who want broadcast-quality Traaining, Traain offers an optional media add-on through vetted production partners.
          </p>

          <div className="mb-8">
            <p className="text-lg font-semibold text-white mb-4 text-center">Available as a custom engagement:</p>
            <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto">
              {services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div key={index} className="flex items-center gap-4 p-4 rounded-xl bg-gray-900/50 border border-purple-500/20">
                    <Icon className="w-5 h-5 text-purple-400 flex-shrink-0" />
                    <span className="text-gray-300">{service.text}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="text-center p-6 rounded-xl bg-purple-900/20 border border-purple-500/20 max-w-3xl mx-auto">
            <p className="text-gray-400">
              This is <span className="text-white font-semibold">optional — not required</span> — and designed for experts who want enterprise-level polish without building a media team.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaProduction;
